export const qaData = [
// ===== 销售模块 =====
{
  id: 'sales-1',
  question: '怎么录入销售单？',
  keywords: ['销售单', '录入', '下单', '客户订单'],
  tags: ['销售'],
  summary: '在销售管理页面点击新增，选择客户、填写物料明细和数量后保存为草稿，确认无误后发布进入审批流程。',
  link: '/help/sales',
  module: '销售'
}, {
  id: 'sales-2',
  question: '找不到客户怎么办？',
  keywords: ['客户', '新增客户', '客户档案'],
  tags: ['销售'],
  summary: '录入销售单的前提是系统中已有客户档案。前往客户管理 → 新增客户 → 填写客户名称、联系人、联系方式 → 保存。',
  link: '/help/sales',
  module: '销售'
}, {
  id: 'sales-3',
  question: '销售单怎么发布？',
  keywords: ['销售单', '发布', '提交', '审批'],
  tags: ['销售', '审批'],
  summary: '草稿状态的销售单可以编辑并发布。发布后进入待审批状态，等待审批人处理。',
  link: '/help/sales',
  module: '销售'
}, {
  id: 'sales-4',
  question: '销售单被驳回了怎么办？',
  keywords: ['销售单', '驳回', '退回', '修改'],
  tags: ['销售', '审批'],
  summary: '审批驳回后可以修改内容并重新发布。已驳回状态的订单可以编辑后再次提交审批。',
  link: '/help/sales',
  module: '销售'
}, {
  id: 'sales-5',
  question: '销售单怎么变更？',
  keywords: ['销售单', '变更', '修改', '数量', '交期'],
  tags: ['销售', '变更'],
  summary: '已生效的订单不能直接修改，需要走变更流程。系统只调整受影响的部分，已发货的行不受影响。',
  link: '/help/sales',
  module: '销售'
}, {
  id: 'sales-6',
  question: '怎么查看发货进度？',
  keywords: ['发货', '进度', '待交付', '出库'],
  tags: ['销售', '发货'],
  summary: '订单批准后进入待交付列表。仓库完成出库后，可以在这里查看每笔订单的发货和退货进度。',
  link: '/help/sales',
  module: '销售'
}, {
  id: 'sales-7',
  question: '客户退货怎么处理？',
  keywords: ['退货', '客户退货', '入库'],
  tags: ['销售', '退货'],
  summary: '客户退回后，仓库收货入库，退货记录关联原出库单，待交付数量自动恢复。',
  link: '/help/sales',
  module: '销售'
},
// ===== 需求模块 =====
{
  id: 'demand-1',
  question: '怎么提需求？',
  keywords: ['需求单', '提需求', '申请物料'],
  tags: ['需求'],
  summary: '在需求管理页面新建需求单，选择收货地址、填写用途，添加物料明细和数量后保存为草稿，确认后发布。',
  link: '/help/demand',
  module: '需求'
}, {
  id: 'demand-2',
  question: '需求单批准后会发生什么？',
  keywords: ['需求单', '批准', 'MRP', '算料', '派生'],
  tags: ['需求', '审批'],
  summary: '批准后系统自动进行 MRP 算料，根据物料属性生成采购任务或生产工单，无需人工干预。',
  link: '/help/demand',
  module: '需求'
}, {
  id: 'demand-3',
  question: '怎么查看需求的处理进度？',
  keywords: ['需求', '进度', '采购任务', '工单'],
  tags: ['需求', '进度'],
  summary: '在需求单详情中可以看到每一行物料对应的采购任务或生产工单状态，随时了解处理进展。',
  link: '/help/demand',
  module: '需求'
}, {
  id: 'demand-4',
  question: '需求单可以修改吗？',
  keywords: ['需求单', '修改', '变更', '草稿'],
  tags: ['需求', '变更'],
  summary: '草稿状态可以直接编辑。已批准的需求单不能直接修改，需要走变更流程。',
  link: '/help/demand',
  module: '需求'
}, {
  id: 'demand-5',
  question: '需求单怎么删除？',
  keywords: ['需求单', '删除', '草稿'],
  tags: ['需求'],
  summary: '只有草稿状态的需求单可以删除。已发布或已批准的单据无法删除。',
  link: '/help/demand',
  module: '需求'
},
// ===== 采购模块 =====
{
  id: 'purchase-1',
  question: '怎么询价？',
  keywords: ['询价', '供应商', '报价'],
  tags: ['采购', '询价'],
  summary: '选择物料 → 选择供应商 → 发询价 → 供应商在线报价 → 采纳报价 → 生成采购订单。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-2',
  question: '怎么发起竞价？',
  keywords: ['竞价', '比价', '多家', '竞争'],
  tags: ['采购', '竞价'],
  summary: '选择物料 → 邀请多家供应商 → 供应商在线竞价 → 择优选择 → 生成采购订单。适用于重要物料。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-3',
  question: '怎么创建采购订单？',
  keywords: ['采购单', '下单', '创建订单'],
  tags: ['采购'],
  summary: '可以通过询价/竞价结果生成，也可以直接创建采购单。填写物料、价格、交期后发布给供应商。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-4',
  question: '采购订单状态有哪些？',
  keywords: ['采购单', '状态', '草稿', '磋商', '确认'],
  tags: ['采购', '状态'],
  summary: '草稿（可编辑删除）→ 磋商中（等待供应商确认）→ 已确认（双方达成一致）。支持变更和撤销。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-5',
  question: '供应商不确认订单怎么办？',
  keywords: ['采购单', '磋商', '供应商', '确认'],
  tags: ['采购', '供应商'],
  summary: '供应商可以进入磋商阶段提出自己的价格或交期。双方协商达成一致后订单确认。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-6',
  question: '采购订单怎么变更？',
  keywords: ['采购单', '变更', '修改', '版本'],
  tags: ['采购', '变更'],
  summary: '已确认订单可以创建变更单，修改物料项（数量/价格/交期），审批后生效。已发货的行不受影响。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-7',
  question: '供应商说延期了怎么办？',
  keywords: ['交期', '延期', '预警', '催货'],
  tags: ['采购', '交期', '预警'],
  summary: '交货日前3天系统自动推送交期确认请求。供应商反馈延迟时，你可以选择催货、换供应商或调整生产排期。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-8',
  question: '怎么下载采购合同？',
  keywords: ['合同', '下载', 'PDF', '签署'],
  tags: ['采购', '合同'],
  summary: '订单确认后，可以下载合同 PDF 进行签署回传。',
  link: '/help/purchase',
  module: '采购'
}, {
  id: 'purchase-9',
  question: '怎么查看成交记录？',
  keywords: ['成交', '历史价格', '最近成交'],
  tags: ['采购', '价格'],
  summary: '在采购模块中可以查看历史成交记录和价格趋势。',
  link: '/help/purchase',
  module: '采购'
},
// ===== 供应商模块 =====
{
  id: 'supplier-1',
  question: '供应商怎么报价？',
  keywords: ['供应商', '报价', '竞价', '询价'],
  tags: ['供应商', '报价'],
  summary: '收到询价/竞价邀请后，查看物料需求和图纸详情，在线填写报价。阶梯价格要合理设置最小起订量。',
  link: '/help/supplier',
  module: '供应商'
}, {
  id: 'supplier-2',
  question: '供应商怎么确认订单？',
  keywords: ['供应商', '确认', '订单', '磋商'],
  tags: ['供应商', '订单'],
  summary: '收到采购订单后，如果同意价格和交期则直接确认；如有异议可进入磋商阶段协商。',
  link: '/help/supplier',
  module: '供应商'
}, {
  id: 'supplier-3',
  question: '供应商怎么发货？',
  keywords: ['供应商', '发货', '收货单', '物流'],
  tags: ['供应商', '发货'],
  summary: '基于已确认订单创建发货单，填写实际发货数量，打印随货单据。',
  link: '/help/supplier',
  module: '供应商'
}, {
  id: 'supplier-4',
  question: '供应商怎么下载图纸？',
  keywords: ['供应商', '图纸', '下载', '版本'],
  tags: ['供应商', '图纸'],
  summary: '在订单详情中可以下载图纸。每次生产前请确认图纸版本为最新，系统记录阅图版本号。',
  link: '/help/supplier',
  module: '供应商'
}, {
  id: 'supplier-5',
  question: '供应商怎么查看对账单？',
  keywords: ['供应商', '对账', '对账单', '确认'],
  tags: ['供应商', '对账'],
  summary: '核对对账单中的收货数量、金额是否与实际一致，确认后进入付款流程。',
  link: '/help/supplier',
  module: '供应商'
}, {
  id: 'supplier-6',
  question: '交期确认怎么操作？',
  keywords: ['交期', '确认', '反馈', '延迟'],
  tags: ['供应商', '交期'],
  summary: '交货前3天系统推送确认请求。及时反馈正常或延迟；如有延迟请主动给出新交期。',
  link: '/help/supplier',
  module: '供应商'
},
// ===== 仓库模块 =====
{
  id: 'warehouse-1',
  question: '怎么收货？',
  keywords: ['收货', '扫码', '入库', '收货单'],
  tags: ['仓库', '收货'],
  summary: '供应商送货到达后，打开收货单扫码收货，然后扫码品检，合格后确认入库上架。',
  link: '/help/warehouse',
  module: '仓库'
}, {
  id: 'warehouse-2',
  question: '怎么品检？',
  keywords: ['品检', '质检', '检验', '不良'],
  tags: ['仓库', '品检'],
  summary: '扫码品检时对照不良标签判定合格数量。品检完成后系统自动触发入库。',
  link: '/help/warehouse',
  module: '仓库'
}, {
  id: 'warehouse-3',
  question: '怎么拣料发货？',
  keywords: ['拣料', '发货', '出库', '拣料篮'],
  tags: ['仓库', '发货'],
  summary: '收到拣料任务后，扫码绑定拣料篮，按系统指引扫码拣料，最后扫码确认出库。',
  link: '/help/warehouse',
  module: '仓库'
}, {
  id: 'warehouse-4',
  question: '怎么盘点？',
  keywords: ['盘点', '盲盘', '差异', '盘盈', '盘亏'],
  tags: ['仓库', '盘点'],
  summary: '选择分区 → 扫码盘点（支持盲盘）→ 系统自动对比差异 → 确认后调整库存。',
  link: '/help/warehouse',
  module: '仓库'
}, {
  id: 'warehouse-5',
  question: '账面有货但系统说缺料？',
  keywords: ['库存', '占用', '锁定', '安全库存', '缺料'],
  tags: ['仓库', '库存'],
  summary: '可能是库存被其他工单占用或锁定。检查库存占用情况和安全库存设置。',
  link: '/help/warehouse',
  module: '仓库'
}, {
  id: 'warehouse-6',
  question: '怎么查某天的库存？',
  keywords: ['库存', '快照', '历史', '查询'],
  tags: ['仓库', '库存'],
  summary: '使用库存快照功能，可以查看指定日期的库存数据。支持多仓库多库位查询。',
  link: '/help/warehouse',
  module: '仓库'
}, {
  id: 'warehouse-7',
  question: '库存怎么锁定和释放？',
  keywords: ['锁定', '释放', '库存', '占用'],
  tags: ['仓库', '库存'],
  summary: '到货未分配的货可以锁定防止误用。需要使用时再释放锁定。',
  link: '/help/warehouse',
  module: '仓库'
},
// ===== 生产模块 =====
{
  id: 'produce-1',
  question: '工单怎么开工？',
  keywords: ['工单', '开工', '启动'],
  tags: ['生产', '工单'],
  summary: '齐套分析通过后，在工单详情页点击「开工」按钮即可开始生产。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-2',
  question: '工单怎么暂停？',
  keywords: ['工单', '暂停', '停工'],
  tags: ['生产', '工单', '状态'],
  summary: '在工单详情页点击「暂停」按钮，工单进入暂停状态。适用于缺料、设备故障等临时停工。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-3',
  question: '工单暂停后怎么恢复？',
  keywords: ['工单', '恢复', '暂停'],
  tags: ['生产', '工单', '状态'],
  summary: '在暂停状态的工单详情页点击「恢复」按钮，工单恢复为有效状态继续生产。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-4',
  question: '工单怎么完工？',
  keywords: ['工单', '完工', '归档', '结案'],
  tags: ['生产', '工单'],
  summary: '产成品入库后，在工单详情页点击「完工」，工单归档冻结变为只读状态。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-5',
  question: '工单怎么关闭？',
  keywords: ['工单', '关闭', '取消', '无效'],
  tags: ['生产', '工单'],
  summary: '在工单详情页点击「关闭」，工单变为无效状态。关闭后只能只读查看。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-6',
  question: '怎么领料？',
  keywords: ['领料', '出库', '原材料'],
  tags: ['生产', '领料'],
  summary: '开工后从仓库领出物料到产线，系统记录出库。每步扫码操作更快捷准确。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-7',
  question: '料多了怎么退？',
  keywords: ['退料', '退回', '多余'],
  tags: ['生产', '退料'],
  summary: '领多了用不完的物料退回仓库，系统记录入库。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-8',
  question: '料不够/坏了怎么补？',
  keywords: ['补料', '损坏', '不够', '损耗'],
  tags: ['生产', '补料'],
  summary: '生产中物料损坏或不够时，创建补料需求单（走审批），批准后仓库发料。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-9',
  question: '怎么做齐套分析？',
  keywords: ['齐套', '缺料', '备料', '分析'],
  tags: ['生产', '齐套'],
  summary: '在工单详情页进行齐套分析，检查物料是否备齐。支持展开整棵树查看子工单齐套情况。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-10',
  question: '设计变更怎么处理？',
  keywords: ['ECN', '变更', '设计', 'BOM变更'],
  tags: ['生产', 'ECN', '变更'],
  summary: '创建变更单 → 填写变更明细（增/减/改物料）→ 发布 → 审批 → 批准后系统自动调整工单物料明细。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-11',
  question: '子工单怎么启动？',
  keywords: ['子工单', '批量启动', '层级'],
  tags: ['生产', '工单'],
  summary: '父工单开工后，可以一键启动所有直属子工单。子工单生产半成品供父工单使用。',
  link: '/help/production',
  module: '生产'
}, {
  id: 'produce-12',
  question: '工单可以返工吗？',
  keywords: ['返工', '返工出库', '重新生产'],
  tags: ['生产', '工单'],
  summary: '已完工的工单可以返工出库，工单恢复为有效状态重新生产。',
  link: '/help/production',
  module: '生产'
},
// ===== 产品/研发模块 =====
{
  id: 'product-1',
  question: '什么是虚拟件？',
  keywords: ['虚拟件', '组合件', '逻辑件'],
  tags: ['产品', '物料'],
  summary: '虚拟件是逻辑上的组合件，只用于搭建 BOM 结构，本身不备货、不入库、不参与算料。仅用于描述产品结构的中间层级。',
  link: '/help/product',
  module: '产品'
}, {
  id: 'product-2',
  question: '是否参与 MRP 是什么意思？',
  keywords: ['MRP', '算料', '参与', '开关'],
  tags: ['产品', '物料'],
  summary: '打开后系统会自动计算该物料的净需求并生成采购/生产任务。需要系统自动补货的物料应打开此开关。',
  link: '/help/product',
  module: '产品'
}, {
  id: 'product-3',
  question: '怎么设置替代料？',
  keywords: ['替代料', '替代', '优先级'],
  tags: ['产品', '物料'],
  summary: '为某个主料指定可替代的物料并排好优先级。当主料缺货时，系统按优先级提示可用的替代料。',
  link: '/help/product',
  module: '产品'
}, {
  id: 'product-4',
  question: 'BOM 怎么发布？',
  keywords: ['BOM', '发布', '审核', '提交'],
  tags: ['产品', 'BOM'],
  summary: 'BOM 要走"提交 → 审核 → 发布"流程，只有发布生效的版本才会被 MRP 使用。',
  link: '/help/product',
  module: '产品'
}, {
  id: 'product-5',
  question: 'BOM 变了怎么办？',
  keywords: ['BOM', '变更', '更新', '版本'],
  tags: ['产品', 'BOM', '变更'],
  summary: '设计变更时及时更新 BOM，否则算料和生产会用错料。BOM 有版本记录，历史版本可追溯。',
  link: '/help/product',
  module: '产品'
},
// ===== 财务模块 =====
{
  id: 'finance-1',
  question: '对账单怎么生成？',
  keywords: ['对账', '对账单', '生成', '收货'],
  tags: ['财务', '对账'],
  summary: '系统根据收货明细自动生成对账单草稿，确认无误后发布给对方确认。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-2',
  question: '怎么安排付款？',
  keywords: ['付款', '付款单', '审批', '付款流程'],
  tags: ['财务', '付款'],
  summary: '对账单双方确认后，系统自动派生付款单。付款单走审批流程：草稿 → 待审批 → 已审批 → 已确认 → 已完成。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-3',
  question: '付款单状态有哪些？',
  keywords: ['付款单', '状态', '草稿', '审批', '确认', '完成'],
  tags: ['财务', '付款', '状态'],
  summary: '草稿（可发布删除）→ 待审批（等待审批）→ 已审批（财务确认）→ 已确认（完成付款）→ 已完成。支持驳回后重新发布。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-4',
  question: '怎么创建预付款？',
  keywords: ['预付', '预付款', '比例', '订单'],
  tags: ['财务', '预付'],
  summary: '选择采购订单，设置预付比例（按订单金额百分比），创建预付款单后走审批和付款流程。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-5',
  question: '预付款怎么核销？',
  keywords: ['预付', '核销', '对账', '抵扣'],
  tags: ['财务', '预付', '对账'],
  summary: '对账确认后，系统自动从应付中扣减已预付金额。在供应商余额表中可看到预付的期初/本期/期末余额。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-6',
  question: '什么是费用项？',
  keywords: ['费用', '费用项', 'PO外', '额外'],
  tags: ['财务', '费用'],
  summary: '费用是用来处理采购订单之外的额外收支，如运费、罚款、加急费、包装补偿等。金额可正可负，挂在发货/退货环节处理。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-7',
  question: '怎么创建费用？',
  keywords: ['费用', '创建', '运费', '罚款', '补充'],
  tags: ['财务', '费用'],
  summary: '采购方和供应商均可创建费用项，需关联发货/退货单。创建后状态为未确认，需对方确认同意。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-8',
  question: '费用怎么确认？',
  keywords: ['费用', '确认', '对方', '审核'],
  tags: ['财务', '费用'],
  summary: '采购方创建的费用由供应商确认，供应商创建的费用由采购方确认。确认后状态变为已确认，可纳入对账结算。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-9',
  question: '费用和对账什么关系？',
  keywords: ['费用', '对账', '结算', '纳入'],
  tags: ['财务', '费用', '对账'],
  summary: '费用项确认后，金额会纳入对账单一起结算。对账单金额 = 收货/退货明细金额 + 已确认的费用项金额。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-10',
  question: '发票怎么登记？',
  keywords: ['发票', '登记', '关联', '付款单'],
  tags: ['财务', '发票'],
  summary: '发票必须关联付款单创建，登记发票编号、金额、税额。发票可修改（录入错误时）、可删除。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-11',
  question: '应付余额怎么查？',
  keywords: ['应付', '余额', '供应商', '欠款', '账期'],
  tags: ['财务', '余额'],
  summary: '在供应商余额表中按账期（月）查看每个供应商的全部资金往来，包括期初应付、本期应付、本期付款、期末应付等。',
  link: '/help/finance',
  module: '财务'
}, {
  id: 'finance-12',
  question: '供应商余额表怎么看？',
  keywords: ['余额', '期初', '期末', '应付', '预付', '票据'],
  tags: ['财务', '余额'],
  summary: '余额表展示期初应付、本期应付、本期付款、预付核销、期末应付、预付余额、应收票据等字段，一张表看清全部资金往来。',
  link: '/help/finance',
  module: '财务'
}];

/** 所有可用标签（去重） */
export const allTags = Array.from(new Set(qaData.flatMap(item => item.tags))).sort();

/** 前端全文搜索 */
export function searchQA(query, items) {
  if (!query.trim()) return items;
  const keywords = query.toLowerCase().split(/\s+/).filter(Boolean);
  return items.filter(item => {
    const text = [item.question, ...item.keywords, item.summary, item.module].join(' ').toLowerCase();
    return keywords.every(kw => text.includes(kw));
  }).sort((a, b) => {
    const aTitle = a.question.toLowerCase().includes(query.toLowerCase()) ? 0 : 1;
    const bTitle = b.question.toLowerCase().includes(query.toLowerCase()) ? 0 : 1;
    return aTitle - bTitle;
  });
}